<div class="card card-outline-secondary">
  <div class="card-header">
    <h3 class="mb-0">Change Password</h3>
  </div>
  <div class="card-body">
    <form class="form" [formGroup]="newPasswordForm" (ngSubmit)="onSubmit(newPasswordForm.value)">
      <!-- <div class="mb-3">
      <label for="inputPasswordOld">Current Password</label>
      <input type="password" class="form-control" id="inputPasswordOld" formControlName="oldPassword"
        required="">

        <div *ngIf="formValues.oldPassword.invalid && (formValues.oldPassword.dirty || formValues.oldPassword.touched)"
          class="alert alert-danger">
          <div *ngIf="formValues.oldPassword.errors.required">
            Password is required.
          </div>
          <div *ngIf="formValues.oldPassword.hasError('minlength')">
            Password is minimum 6 characters
          </div>

        </div>

      </div> -->
      <div class=" mb-3">
        <label for="inputPasswordNew">New Password</label>
        <input type="password" class="form-control" id="inputPasswordNew" formControlName="newPassword" required="" />
        @if (formValues.newPassword.invalid && (formValues.newPassword.dirty || formValues.newPassword.touched)) {
          <div class="alert alert-danger">
            @if (formValues.newPassword.errors.required) {
              <div>
                New Password is required.
              </div>
            }
            @if (formValues.newPassword.hasError('minlength')) {
              <div>
                Password is minimum 6 characters
              </div>
            }
          </div>
        }
        <!-- <span class="form-text small text-muted">
        The password must be 8-20 characters, and must <em>not</em> contain spaces.
      </span> -->
    </div>
    <div class="mb-3">
      <label for="inputPasswordNewVerify">Verify</label>
      <input type="password" class="form-control" id="inputPasswordNewVerify" required="" formControlName="verifyPassword">
      <!-- <span class="form-text small text-muted">
      To confirm, type the new password again.
    </span> -->


    @if (formValues.verifyPassword.invalid && (formValues.verifyPassword.dirty || formValues.verifyPassword.touched)) {
      <div class="alert alert-danger">
        @if (formValues.verifyPassword.errors.required) {
          <div>
            Confirm Password is required.
          </div>
        }
        @if (formValues.verifyPassword.errors.confirmedValidator) {
          <div>Password and Confirm Password must be match. </div>
        }
        <!-- <div *ngIf="formValues.verifyPassword.errors.ConfirmPasswordValidator">Password not match.</div> -->
      </div>
    }

  </div>

  <div class="mb-3">
    <button type="submit" class="btn btn-success btn-lg float-end">Save</button>
  </div>
  <div class="mb-3 ">
    <button type="button" (click)="onCancel()" class="btn btn-success btn-lg float-end me-3">Cancel</button>
  </div>
</form>
</div>
</div>